module.exports = __webpack_public_path__ + "static/img/son4.ce66693c.png";